function animate() {
  const animatedElements = document.querySelectorAll('[data-block-type], [data-section-id], .animate');
  if (typeof IntersectionObserver == 'function') {
    let animationObserver = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            entry.target.dispatchEvent(new CustomEvent('in-view', { bubbles: false }));
            observer.unobserve(entry.target);
          }
        });
      },
      {
        root: document,
        //rootMargin: '-25% 0 -25% 0',
        threshold: 0.3,
      },
    );
    animatedElements.forEach(function (element) {
      animationObserver.observe(element);
    });
  } else {
    animatedElements.forEach(function (element) {
      element.classList.add('in-view');
    });
  }
}

if (document.readyState && (document.readyState === 'complete' || document.readyState === 'interactive')) {
  animate();
} else {
  window.addEventListener('DOMContentLoaded', animate);
}
